import { User, Briefcase, Puzzle } from 'lucide-react';
import { Avatar, AvatarImage, AvatarFallback } from "@/components/ui/avatar";
const About = () => {
  return <section id="about" className="section bg-white text-darkText py-8 md:py-12 pb-2 md:pb-3">
      <div className="w-full px-5 md:px-6">
        <div className="flex flex-col md:flex-row items-center gap-6 md:gap-12 max-w-6xl mx-auto mb-6 md:mb-12">
          <div className="flex flex-col items-center mx-0 px-0 w-full md:w-56 flex-shrink-0">
            <Avatar className="w-20 h-20 md:w-24 md:h-24 border-4 border-cyanPrimary">
              <AvatarImage alt="Addy's headshot" className="object-cover" src="/lovable-uploads/8677b104-dd13-4cd3-8a4d-db9be8072307.jpg" loading="lazy" width={96} height={96} />
              <AvatarFallback className="bg-grayLight text-darkText text-xl">AS</AvatarFallback>
            </Avatar>
            <h2 className="text-lg md:text-xl font-semibold text-darkText mt-3 text-center">Addy Spiller</h2>
            <p className="text-sm md:text-base text-darkText/70 text-center">Founder</p>
          </div>
          
          <div className="text-center md:text-left flex-1">
            <p className="text-lg text-darkText/80 leading-relaxed overflow-auto px-0">With 15+ years of experience turning complex ideas into products people love, I partner with mission-driven teams in clean-tech, fintech, and other impact-tech sectors. As a fractional Head of Product, I bring strategic leadership and hands-on execution - helping startups clarify their vision, move faster, and build with purpose.</p>
          </div>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-8 mt-6 md:mt-8 max-w-7xl mx-auto">
          <div className="bg-grayLight p-4 md:p-8 rounded-2xl shadow-soft hover:shadow-md transition-shadow">
            <div className="w-12 h-12 bg-cyanPrimary rounded-full flex items-center justify-center mb-3 md:mb-6 mx-auto">
              <Briefcase className="text-white" size={24} />
            </div>
            <h3 className="text-base md:text-xl font-semibold mb-2 md:mb-4 text-darkText text-center">Trusted Partner</h3>
            <p className="text-base text-darkText/70">I combine thought leadership with action - translating big-picture vision into decisions, plans and product delivery.</p>
          </div>
          
          <div className="bg-grayLight p-4 md:p-8 rounded-2xl shadow-soft hover:shadow-md transition-shadow">
            <div className="w-12 h-12 bg-cyanPrimary rounded-full flex items-center justify-center mb-3 md:mb-6 mx-auto">
              <User className="text-white" size={24} />
            </div>
            <h3 className="text-base md:text-xl font-semibold mb-2 md:mb-4 text-darkText text-center">Customer-Centric</h3>
            <p className="text-base text-darkText/70">
              My approach starts and ends with your users. Every product decision is grounded in real customer insight.
            </p>
          </div>
          
          <div className="bg-grayLight p-4 md:p-8 rounded-2xl shadow-soft hover:shadow-md transition-shadow">
            <div className="w-12 h-12 bg-cyanPrimary rounded-full flex items-center justify-center mb-3 md:mb-6 mx-auto">
              <Puzzle className="text-white" size={24} />
            </div>
            <h3 className="text-base md:text-xl font-semibold mb-2 md:mb-4 text-darkText text-center">Inspired by Ambiguity</h3>
            <p className="text-base text-darkText/70">I thrive in complexity, distilling the noise into strategy that teams can align around and execute confidently.</p>
          </div>
        </div>
      </div>
    </section>;
};
export default About;